module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
      },
      "mouseup": function($event) {
        $event.stopPropagation();
      },
      "dblclick": function($event) {
        $event.stopPropagation();
      },
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._l((_vm.selectors), function(definitions, type) {
    return (_vm.mounted) ? _vm._l((definitions), function(definition) {
      return _c('Highlighter', {
        key: definition.s + (definition.c || ''),
        staticStyle: {
          "display": "none !important"
        },
        attrs: {
          "window": _vm.window,
          "changes": _vm.changes,
          "type": type,
          "definition": definition,
          "selected": _vm.selected.indexOf(definition) !== -1,
          "active": _vm.active === definition,
          "hover": _vm.hover === definition
        },
        on: {
          "click": _vm.tooltipToggle
        }
      })
    }) : _vm._e()
  }), _vm._v(" "), (_vm.active) ? _c('ul', {
    ref: "menu",
    staticClass: "jbo-popover",
    class: ( _obj = {}, _obj['jbo-popover--active'] = _vm.menu, _obj )
  }, [_vm._l(([1, 2]), function(index) {
    return _c('li', {
      key: index,
      staticClass: "selector-popover-item__default",
      class: [{
        selected: _vm.isSelected(index)
      }, 'step-' + [index]],
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.setStep(index)
        }
      }
    }, [_vm._v("\n      Step " + _vm._s(index) + "\n    ")])
  }), _vm._v(" "), _c('li', {
    staticClass: "selector-popover-item__default",
    class: ( _obj$1 = {
      selected: _vm.hasGroup
    }, _obj$1['group-edit'] = true, _obj$1 ),
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.selectSimilar($event)
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.findSimilarText) + "\n    ")]), _vm._v(" "), _c('li', {
    staticClass: "popper__arrow"
  })], 2) : _vm._e()], 2)
  var _obj;
  var _obj$1;
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51e281db","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Radius/Editor.vue
// module id = wusj
// module chunks = 1